import Create from './create/CreateEventIncome';
import Edit from './edit/EditEventIncome';
import Individual from './individual/EventIncome';
 
export default { Create, Edit, Individual }; 